// Protect routes that require authentication by checking for cookie.session_username
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { WebService } from 'minecraft-net-core-services';
import RouteList from './Routes';

const RouteAuth = () => {
  const location = useLocation();
  const loginURL = `${RouteList.login.path}?${new URLSearchParams([['return_url', window.location.href]]).toString()}`;

  if (!WebService.isLoggedIn()) {
    return <Navigate to={loginURL} state={{ from: location }} replace />;
  } else {
    return <Outlet />;
  }
};

export default RouteAuth;
